import React from 'react'

export const CtaHeading: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div className='font-bold pro-head-6 margin-bottom-05'>{children}</div>
)
